import {GameFrameView} from '@gongxigames/framework/slot/modules/gameFrame/GameFrameView';
import {GameFrameModuleName} from '@gongxigames/framework/slot/modules/gameFrame/GameFrameConstants';
import {Module} from '@gongxigames/framework/slot';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export class GameFrameModule extends Module<GameFrameView> {
    public static readonly NAME: symbol = GameFrameModuleName;

    protected setupEvents(): void {
        super.setupEvents();

        this.on('General.Game.STARTED', this.onVisibility.bind(this, true));
        strictUiEmitter.on('UI.menu.opened', this.onVisibility.bind(this, false));
        strictUiEmitter.on('UI.menu.menuBarClosed', this.onVisibility.bind(this, true));
    }

    protected setupStates(): void {}

    protected setupViews(): void {
        this.setView(GameFrameView.NAME);
        this.onVisibility(false);
    }

    private onVisibility(visible: boolean): void {
        this.setVisibility(visible);
    }

    private setVisibility(visible: boolean): void {
        visible ? this.view.show() : this.view.hide();
    }
}
